export default __webpack_public_path__ + "static/media/Djibouti.76cdbf05.png";